






import { Component, Prop, Vue } from "@/shared/vuepack";
import { formatCurrency } from "@/shared/currency.js";
import * as _ from "lodash";

@Component({})
export default class BalanceAmount extends Vue {
  @Prop({ required: true })
  amount: number | string;

  @Prop({ default: false })
  mutedText: boolean;

  formatCurrency = formatCurrency;

  get isNegativeAmount (): boolean {
    return this.amount !== null
      && _.isNumber(this.amount)
      && _.toNumber(this.amount) < 0;
  }
}
